module.exports = __webpack_public_path__ + "static/media/MileMarkerLunch.806e6914.pdf";